(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vfitz-mygarage"] && !Shopify.designMode) return;
  try {
    
class VFitzMyGarageClassicManager {
  constructor() {
    const config = window.vfitzGarageConfig || {};
    this.targetSelector = config.targetSelector || '#vfitz-mygarage';
    this.cssVars = config.cssVars || {};
    this.vehicle_null_text = config.vehicleNullText || 'Select Vehicle';

    this.cookieValue = null;
    this.garage_param = null;
    this.isInitialized = false;
    this.currentIndex = 0;
    this.searchParamsAllowKeys = ['year', 'make', 'model', 'submodel', 'engine'];

    this.hostElement = null;
    this.dom_vehicle_label = null;
    this.dom_headerNav = null;
    this.dom_dropdown = null;
    this.dom_arrow = null;

    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onDocumentKeydown = this.onDocumentKeydown.bind(this);
  }

  // Receives one matched host node from the bootstrap function; no longer uses document.querySelector, which only returns the first match
  initWithNode(hostElement) {
    this.hostElement = hostElement;
    if (!this.hostElement) return;

    this.applyCSSVars();
    this.renderLayout();
    this.initDOMReferences();
    this.bindEvents();          // Bind the click listener first, so it is not affected by whether the later data init succeeds or fails
    this.initWithEventCheck();
  }

  applyCSSVars() {
    Object.entries(this.cssVars).forEach(([key, val]) => {
      if (val && this.hostElement) this.hostElement.style.setProperty(key, val);
    });
  }

  renderLayout() {
    if (!this.hostElement) return;
    // Use a standard, conflict-free DOM structure
    this.hostElement.innerHTML = `
      <div class="vfitz-garage-nav" role="button" tabindex="0" aria-haspopup="listbox" aria-expanded="false">
        <span class="vfitz-vehicle-label">${this.escapeHtml(this.vehicle_null_text)}</span>
        <span class="vfitz-arrow-icon" style="display: none;" aria-hidden="true"></span>
        <div class="vfitz-garage-dropdown">
          <ul class="vfitz-garage-list" role="listbox"></ul>
        </div>
      </div>
    `;
  }

  initDOMReferences() {
    if (!this.hostElement) return;
    this.dom_vehicle_label = this.hostElement.querySelector('.vfitz-vehicle-label');
    this.dom_headerNav = this.hostElement.querySelector('.vfitz-garage-nav');
    this.dom_dropdown = this.hostElement.querySelector('.vfitz-garage-dropdown');
    this.dom_arrow = this.hostElement.querySelector('.vfitz-arrow-icon');
  }

  initWithEventCheck() {
    if (this.isInitialized) return;

    if (typeof vfitzKey !== 'undefined' && typeof vfitzKey.fn?.getGarageData === 'function') {
      this.runGarageInit();
      return;
    }

    const handler = () => {
      window.removeEventListener('vfitzInitMenuFirst', handler);
      this.runGarageInit();
    };
    window.addEventListener('vfitzInitMenuFirst', handler);

    setTimeout(() => {
      if (this.isInitialized) return;
      if (typeof vfitzKey !== 'undefined' && typeof vfitzKey.fn?.getGarageData === 'function') {
        window.removeEventListener('vfitzInitMenuFirst', handler);
        this.runGarageInit();
      }
    }, 1200);
  }

  runGarageInit() {
    if (this.isInitialized) return;
    this.isInitialized = true;

    try {
      const garageData = vfitzKey.fn.getGarageData();
      if (!garageData || garageData.length === 0) return;

      this.renderGarageList(garageData);

      if (garageData.length > 1) {
        if (this.dom_arrow) this.dom_arrow.style.display = 'inline-block';
        if (this.dom_headerNav) this.dom_headerNav.classList.add('has-multiple');
      }

      this.currentIndex = 0;
      this.cookieValue = garageData[0];
      this.garage_param = this.cookieValue.param;

      if (this.garage_param) {
        window.searchParams = this.garage_param;
        this.renderVehicleInfo();
        this.highlightActiveItem(0);
      }
    } catch (e) {
      console.error('Error in runGarageInit:', e);
    }
  }

  renderGarageList(garageData) {
    if (!this.hostElement) return;
    const listContainer = this.hostElement.querySelector('.vfitz-garage-list');
    if (!listContainer) return;

    listContainer.innerHTML = garageData.map((item, index) => {
      const itemLabel = this.getVehicleInfo(item.param) || `Vehicle #${index + 1}`;
      return `<li data-garageid="${index}" class="vfitz-garage-item" role="option" aria-selected="false">${this.escapeHtml(itemLabel)}</li>`;
    }).join('');
  }

  highlightActiveItem(index) {
    if (!this.hostElement) return;
    const items = this.hostElement.querySelectorAll('.vfitz-garage-item');
    items.forEach((el, i) => {
      const active = i === index;
      el.classList.toggle('is-active', active);
      el.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }

  renderVehicleInfo() {
    if (!window.searchParams) return;
    const label = this.getVehicleInfo(window.searchParams);
    if (!this.dom_vehicle_label || !this.dom_headerNav) return;

    if (label && label.trim() !== '') {
      this.dom_vehicle_label.innerText = label;
      this.dom_headerNav.classList.add('has-vehicle');
    } else {
      this.dom_vehicle_label.innerText = this.vehicle_null_text;
      this.dom_headerNav.classList.remove('has-vehicle');
    }
  }

  getVehicleInfo(params) {
    if (!params) return '';
    try {
      const filteredData = {};
      Object.keys(params)
        .filter(key => this.searchParamsAllowKeys.includes(key) && params[key] && params[key].length > 0)
        .forEach(key => { filteredData[key] = params[key]; });

      const levelIds = (typeof vfitz !== 'undefined' && vfitz.config?.level_ids)
        ? vfitz.config.level_ids
        : ['year', 'make', 'model'];

      return levelIds
        .map(key => filteredData[key])
        .filter(Boolean)
        .join(' ')
        .replace(/-/g, ' ');
    } catch (e) {
      console.error('Error in getVehicleInfo:', e);
      return '';
    }
  }

  escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  bindEvents() {
    console.log("bindEvents")
    if (!this.hostElement) return;

    // Key fix: listen directly on the outermost host node (the node proven to be clickable)
    this.hostElement.addEventListener('click', (event) => {
      // Stop the event from bubbling up to the form, preventing conflicting logic from firing
      event.preventDefault();
      event.stopPropagation();

      const itemClick = event.target.closest('[data-garageid]');

      if (itemClick) {
        this.handleGarageItem(itemClick);
        this.closeDropdown();
      } else {
        // Clicked on the main button area
        this.handleNavActivate();
      }
    });

    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onDocumentKeydown);
  }

  handleNavActivate() {
    if (!this.dom_headerNav) return;
    
    // If there are multiple vehicles, toggle the dropdown open/closed
    if (this.dom_headerNav.classList.contains('has-multiple')) {
      this.toggleDropdown();
      return;
    }

    // If there is only 1 vehicle, the click directly triggers the vehicle filter search
    if (this.dom_headerNav.classList.contains('has-vehicle')) {
      const firstItem = this.hostElement.querySelector('[data-garageid="0"]');
      if (firstItem) this.handleGarageItem(firstItem);
    }
  }

  toggleDropdown() {
    if (!this.dom_headerNav) return;
    if (this.dom_headerNav.classList.contains('is-open')) {
      this.closeDropdown();
    } else {
      this.openDropdown();
    }
  }

  openDropdown() {
    if (!this.dom_headerNav) return;
    this.dom_headerNav.classList.add('is-open');
    this.dom_headerNav.setAttribute('aria-expanded', 'true');
  }

  closeDropdown() {
    if (!this.dom_headerNav) return;
    this.dom_headerNav.classList.remove('is-open');
    this.dom_headerNav.setAttribute('aria-expanded', 'false');
  }

  onDocumentClick(event) {
    if (this.hostElement && !this.hostElement.contains(event.target)) {
      this.closeDropdown();
    }
  }

  onDocumentKeydown(event) {
    if (event.key === 'Escape') this.closeDropdown();
  }

  handleGarageItem(element) {
    try {
      if (typeof vfitzKey === 'undefined') return;

      const garageid = element.dataset.garageid;
      const index = Number(garageid);
      const garageData = vfitzKey.fn.getGarageData()[garageid];

      if (garageData && garageData.param) {
        this.currentIndex = index;
        this.cookieValue = garageData;
        window.searchParams = garageData.param;
        this.renderVehicleInfo();
        this.highlightActiveItem(index);

        const actionUrl = "/search" + `?m=${encodeURIComponent(JSON.stringify(window.searchParams))}`;
        // console.log({ actionUrl });        
        window.location.href = actionUrl;

        // const selectorScope = (typeof vfitz !== 'undefined' && vfitz.config) ? (vfitz.config.selectorScope || '') : '';
        // const searchBtn = document.querySelector(`#vfitz_search_btn${selectorScope}`);
        // if (searchBtn) {
        //   searchBtn.click();
        // } else if (typeof vfitz$ !== 'undefined') {
        //   vfitz$(`#vfitz_search_btn${selectorScope}`).click();
        // }
      }
    } catch (e) {
      console.error('Error in handleGarageItem:', e);
    }
  }
}

(function bootVFitzGarage() {
  const SCAN_INTERVAL = 300;
  const MAX_DURATION = 15000; // Keep scanning for 15s to cover duplicate nodes that appear late or get rebuilt
  let elapsed = 0;

  function scanAndInit() {
    const config = window.vfitzGarageConfig || {};
    const selector = config.targetSelector || '#vfitz-mygarage';

    // Key: querySelectorAll returns ALL nodes with the same selector, not only the first one
    document.querySelectorAll(selector).forEach((node) => {
      if (node.__vfitzGarageInited) return; // Skip already-initialized nodes to avoid double binding
      node.__vfitzGarageInited = true;
      try {
        new VFitzMyGarageClassicManager().initWithNode(node);
      } catch (e) {
        console.error('VFitz garage init failed:', e);
        node.__vfitzGarageInited = false;   // On failure, allow a retry on the next pass
      }
    });
  }

  function loop() {
    scanAndInit();
    elapsed += SCAN_INTERVAL;
    if (elapsed < MAX_DURATION) setTimeout(loop, SCAN_INTERVAL);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loop);
  } else {
    loop();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
